import type * as React from 'react';

import type { Block, Document, Fragment, Inline, TextRange } from '@gitbook/slate';
import type { List } from '@gitbook/util-immutable';

import type { EditorContainer } from '../interfaces';
import TextRenderer from './TextRenderer';

/*
 * Component to wrap the inner content of a void node.
 */
function VoidWrapper(props: {
    block: Block;
    editor: EditorContainer;
    decorations: List<TextRange>;
    selections: List<TextRange>;
    readOnly: boolean;
    node: Block | Inline;
    parent: Document | Block | Inline | Fragment;
    children: React.ReactNode;
}) {
    const { children, block, node, decorations, selections, editor, readOnly } = props;
    const child = node.getFirstText()!;

    const Tag = node.object === 'block' ? 'div' : 'span';

    const spacer = (
        <Tag data-slate-spacer className="slate-spacer">
            <TextRenderer
                block={node.object === 'block' ? node : block}
                decorations={decorations}
                selections={selections}
                editor={editor}
                key={child.key}
                node={child}
                parent={node}
            />
        </Tag>
    );

    const content = <Tag contentEditable={readOnly ? undefined : false}>{children}</Tag>;

    return (
        <Tag
            data-slate-void
            data-key={node.key}
            contentEditable={readOnly || node.object === 'block' ? undefined : false}
        >
            {readOnly ? null : spacer}
            {content}
        </Tag>
    );
}

export default VoidWrapper;
